<template>
    <CChartBar
            :datasets="defaultDatasets"
            :options="defaultOptions"
            :labels="defaultLabels"
            :id="chart_id"
            :redraw="true"
    />
</template>

<script>
    import { CChartBar } from '@coreui/vue-chartjs'
    import { getStyle, hexToRgba } from '@coreui/utils/src'

    export default {
        name: 'MainChartExample',
        components: {
            CChartBar
        },
        props:{
            chart_datas:Array,
            label: String,
            barColor:String,
            chart_id:String

        },
        computed: {
            defaultDatasets () {

                const data1 = []
                const colors = []
                for (let i = 0; i <= this.chart_datas.length; i++) {
                    if(this.chart_datas[i]!= null){

                        data1.push(this.chart_datas[i].qty)
                        var bar_color = this.barColor;
                        if(this.chart_datas[i].color!=null){
                            bar_color  = this.chart_datas[i].color;
                        }
                        colors.push(bar_color)
                    }


                }

                return [
                    {
                        backgroundColor: colors,
                        borderColor: colors,
                        pointHoverBackgroundColor: colors,
                        borderWidth: 2,
                        barPercentage: 0.4,

                        data: data1
                    },

                ]
            },
            defaultLabels () {
                var labels = [];
                for (let i = 0; i <= this.chart_datas.length; i++) {
                    if(this.chart_datas[i]!= null) {

                        labels.push(this.chart_datas[i].label)
                    }
                }
                return labels;
            },

            defaultOptions () {
                return {

                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: this.label
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: false,
                                maxTicksLimit: 5,
                                stepSize: Math.ceil(50 / 5),
                            },
                            gridLines: {
                                display: true
                            }
                        }]
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3
                        }
                    }
                }
            }
        }
    }
</script>
